// import cpIndex from 'page/cp/index'
const cpIndex = () =>
  import(/* webpackChunkName: "info~articleList" */ 'page/cp/index.vue')

const routes = [
  {
    path: '/ceshi',
    component: cpIndex,
    meta: {
      cache: 10 * 60 * 1000,
      business: '测评',
      pageName: '壹心理测评',
      title: '壹心理测评'
    }
  }
]

export default routes
